import { render } from "./startDetect.vue?vue&type=template&id=329d64de"
import script from "./startDetect.vue?vue&type=script&lang=js"
export * from "./startDetect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\lift\\120.78.159.42\\lcJian\\LC特检通\\特检通\\120.78.159.42\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__